const ownedErrorKeys = new WeakMap<Error, string>();

export const OWNED_ERROR_CAPTIONS = {
  unexpected: 'ERROR.unexpected_error',
  authentication: 'ERROR.authentication_required',
  projectResources: 'ERROR.project_resources_load_failed',
  orderFields: 'ERROR.order_fields_load_failed',
} as const;

export function ownedError<ErrorType extends Error>(
  error: ErrorType,
  caption: keyof typeof OWNED_ERROR_CAPTIONS = 'unexpected',
): ErrorType {
  ownedErrorKeys.set(error, OWNED_ERROR_CAPTIONS[caption]);
  return error;
}

export function ownedErrorKey(error: unknown): string | undefined {
  return error instanceof Error ? ownedErrorKeys.get(error) : undefined;
}
